import * as React from 'react';

import { BatteryHealthSettings } from './batteryHealthSettings';
import { BatteryCycleCountSettings } from './batteryCycleCountSettings';
import { BatteryAverageDischargeSettings } from './batteryAverageDischargeSettings';
import { WorldSettings } from 'services/config/config';

import '../settings.css';

export interface IProps {
  worldSettings: WorldSettings,
  onDataChanged: (data: WorldSettings) => void,
  submitInProgress: boolean,
  dataTimestamp: number
}

export function BatteryAlertsSettings(props: IProps) {
  return (<div className="threshold-settings-composition batteryAlerts">
    <BatteryHealthSettings
      key='health'
      timeStamp={props.dataTimestamp}
      onDataChanged={props.onDataChanged}
      worldSettings={props.worldSettings}
      submitInProgress={props.submitInProgress}
    />
    <BatteryAverageDischargeSettings
      key='average-discharge'
      timeStamp={props.dataTimestamp}
      onDataChanged={props.onDataChanged}
      worldSettings={props.worldSettings}
      submitInProgress={props.submitInProgress}
    />
    <BatteryCycleCountSettings
      key='cycle-count'
      timeStamp={props.dataTimestamp}
      onDataChanged={props.onDataChanged}
      worldSettings={props.worldSettings}
      submitInProgress={props.submitInProgress}
    />
  </div>);
}
